import React, { useEffect, useState } from 'react';
import './scss/withdraw.scss';
import FullScreenLoader from './full-screen';
import WithdrawFormProp from './properties/withdraw-form-prop';

function WithdrawForm({ setStatusMessage } :WithdrawFormProp): React.ReactElement {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [errorClass, setSetErrorClass] = useState('hide');
  const [spendTx, setSpendTx] = useState('');
  const [payTx, setPayTx] = useState('');

  function validateForm():boolean {
    if ((!spendTx || (spendTx && spendTx.trim().length === 0))
        && (!payTx || (payTx && payTx.trim().length === 0))
    ) {
      setErrorMessage('Please enter spend transaction or pay transaction');
      setSetErrorClass('error mb-4');
      return false;
    }

    setErrorMessage('');
    setSetErrorClass('hide');
    return true;
  }
  function resetForm() {
    setSpendTx('');
    setPayTx('');
  }

  const handleSubmit = (event: any) => {
    event.preventDefault();
    if (validateForm()) {
      setIsLoading(true);
      setStatusMessage('Withdraw Success', 'success');
      window.scrollTo(0, 0);
      setIsLoading(false);
      resetForm();
    } else {
      window.scrollTo(0, 0);
    }
  };

  useEffect(() => {

  }, []);

  return (
    <div className="rounded collection-add mb-5 loading-wrapper">
      {isLoading ? <FullScreenLoader /> : <div />}
      <h4 className="pb-3">Initiate Withdrawal</h4>
      <p>Please enter spend transaction or pay transaction of user to initiate withdrawal</p>
      <form onSubmit={handleSubmit}>
        <div className={errorClass}>{errorMessage}</div>
        <div className="mb-3">
          <label htmlFor="name" className="form-label">
            Spend Transaction
            <input
              type="text"
              id="name"
              className="form-control"
              value={spendTx}
              onChange={(e) => setSpendTx(e.target.value)}
            />
          </label>
          <div className="mt-2 mb-3">Or</div>
          <label htmlFor="name" className="form-label">
            Pay Transaction
            <input
              type="text"
              id="name"
              className="form-control"
              value={payTx}
              onChange={(e) => setPayTx(e.target.value)}
            />
          </label>
        </div>
        <button type="submit" className="btn btn-dark">Withdraw</button>
      </form>
    </div>
  );
}

export default WithdrawForm;
